import axios from 'axios'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const APIClient = axios.create({
  baseURL: 'http://localhost:8000',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const putPost = ({ service, postId, post }) =>
  APIClient.put(`/${service}/${postId}`, post)

const updatePost = (options) => (dispatch) =>
  putPost(options)
    .then((response) => {
      const body = response.data
      dispatch(loadJsonApiEntities(body))

      return body
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default updatePost
